import { render, staticRenderFns } from "./CompletedWorks.vue?vue&type=template&id=a7c326cc&scoped=true&"
import script from "./CompletedWorks.vue?vue&type=script&lang=js&"
export * from "./CompletedWorks.vue?vue&type=script&lang=js&"
import style0 from "./CompletedWorks.vue?vue&type=style&index=0&id=a7c326cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c326cc",
  null
  
)

export default component.exports